import apiPdca from '../../../../helpers/apiPdca'
import { loading, loaded, modalAlertaInfo, modalAlertaClean } from '../../../../layout/redux/layoutActions'


export const clearAprovarAcao = () => ({
  type: 'CLEAR_APROVAR_ACAO'
})

export const fetchJanelaCheck = planoId => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: 'FETCH_JANELA_CHECK_REQUEST' })
    dispatch(loading())

    try {
      const { data } = await apiPdca.get(`/pdca/retornajanelacheck?planoId=${planoId}`)

      const janelaValida =
        data?.dataInicial &&
        data?.dataRecomendada &&
        data?.dataFinal

      if (!janelaValida) {
        throw new Error('Erro ao carregar janela do check.')
      }

      dispatch({
        type: 'FETCH_JANELA_CHECK_SUCCESS',
        payload: {
          dataInicial: data.dataInicial,
          dataRecomendada: data.dataRecomendada,
          dataFinal: data.dataFinal
        }
      })
    } catch (error) {
      dispatch({
        type: 'FETCH_JANELA_CHECK_FAILURE',
        payload: error
      })

      dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          })
        )
    } finally {
      dispatch(loaded())
    }
  }
}

export const aprovarAcao = ({ planoId, dataFinalCheck }) => {
  return async (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../../../layout/nlsPopup/${sistema.idioma}.json`)

    dispatch({ type: 'APROVAR_ACAO_REQUEST' })
    dispatch(loading())

    try {
      const { data } = await apiPdca.post('/pdca/aprovaracao', {
        pdcaPlanoId: planoId,
        dataFinalCheck
      })

      if (data?.ok !== true) {
        throw new Error('Erro ao aprovar ação.')
      }

      dispatch({ type: 'APROVAR_ACAO_SUCCESS' })
      return true
    } catch (error) {
      dispatch({
        type: 'APROVAR_ACAO_FAILURE',
        payload: error
      })

      dispatch(
          modalAlertaInfo({
            ...nlsPopup[7],
            show: true,
            btnAction: () => dispatch(modalAlertaClean()),
          })
        )

      return false
    } finally {
      dispatch(loaded())
    }
  }
}